webpackJsonp([213534597649335],{

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(49);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Hi, it's Stojan"
	    ),
	    _react2.default.createElement(
	      _HeadlineWithFocus2.default,
	      {
	        modifierClassNames: "\n          c-headline-focus \n          c-headline-focus--super-big \n        "
	      },
	      "I'm a passionate web developer"
	    ),
	    _react2.default.createElement(
	      "h2",
	      {
	        className: "\n          js-action-button-anchor\n          c-content-box__subheadline \n          c-content-box__subheadline--with-button\n        "
	      },
	      "Who loves to talk about ideas and create stuff."
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-0081599504386f689480.js